import { Slide } from "react-reveal";

const HomeHero = () => {
  return (
    <section className="hero relative">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="hero-inner centered">
              <div className="hero-content-container centered-inner slide-paint-texture slide-in-down">
                <div className="hero-content">
                  <span className="hero-tag">Welcome to Flexi painters</span>
                  <Slide top>
                    <h1 className="hero-title">
                      We Don't Just Paint, We Transform
                    </h1>
                  </Slide>
                  <p className="hero-subtitle">
                    In a market where poor workmanship, delays, and inconsistent
                    quality are common, Flexi Painters stands out for one
                    reason: we deliver exactly what we promise.
                  </p>
                  <Slide left>
                    <div className="hero-cta-container flex">
                      <a
                        href="https://form.jotform.com/flexipainters/book-site-visit"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="button hero-cta main-cta"
                      >
                        Book site visit
                      </a>
                      <a
                        href="/portfolio"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="button hero-cta sub-cta"
                      >
                        Portfolio &rarr;
                      </a>
                    </div>
                  </Slide>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeHero;
